export enum USER_ROLES {
  staff = "staff",
  customer = "customer",
}

export type UserRole = USER_ROLES;
